/* eslint-disable */
import crypto from "crypto";
import Vue from "vue";
import Cookies from "js-cookie";
import qs from "qs";
import Request from "@ued/request";
import apis from "./apis";
import baseApi from "./baseApi";
import errorCode from "./errorCode";

const NO_TOKEN_REQUEST = [
  "/user/register",
  "/user/login",
  "/user/modifyUserPasswd",
  "/user/getMobileCode",
  "/tender/hot",
  "/wechat/getJsSdkSignature",
  "/user/getUdeskUrl",
  "/user/loginAfter",
];

const apiConfig = {
  localhost: {
    name: "yunli-tx",
    url: "//172.22.34.203:5555",
    id: "bwzciax",
    skey: "1CtcGu0rE27EDYDlApHLZtyaTvR7wZAC",
  },
  // 'test.yunli.g7s.chinawayltd.com': {
  //     name: 'yunli-tx',
  //     // url: '//172.22.34.203:5555/v1',
  //     url: '//172.16.1.197:8585/mock/16/v1',
  //     id: 'ss6b8ml',
  //     skey: 'A96NwT0RDGd08WIOiHtpXzGwz3h7P5sF',
  // },
  "test.yunlim.g7s.chinawayltd.com": {
    name: "yunli-tx",
    url: "//172.22.34.203:5555",
    id: "bwzciax",
    skey: "1CtcGu0rE27EDYDlApHLZtyaTvR7wZAC",
  },
  "demo.yunli.g7s.chinawayltd.com": {
    name: "yunli-tx",
    url: "//172.16.2.136:5555",
    id: "bm4xr4s",
    skey: "qiJDhcd63V7FmRsoreXGG0uQ7RCGa7NV",
  },
  "wxmobile.yunli.g7.com.cn": {
    name: "yunli-tx",
    url: "//vega.huoyunren.com",
    id: "b9g3qcc",
    skey: "j02uNGlQCzvAAzmE3DcQ1IBErEhwCoYr",
  },
  "g7s.e-bidding.huoyunren.com": {
    name: "yunli-tx",
    url: "//vega.huoyunren.com",
    id: "b9g3qcc",
    skey: "j02uNGlQCzvAAzmE3DcQ1IBErEhwCoYr",
  },
  "e-bidding.g7s.huoyunren.com": {
    name: "yunli-tx",
    url: "//vega.huoyunren.com",
    id: "b9g3qcc",
    skey: "j02uNGlQCzvAAzmE3DcQ1IBErEhwCoYr",
  },
  "test.yunli.g7.com.cn": {
    name: "yunli-tx",
    url: "//172.22.34.203:5555",
    id: "bwzciax",
    skey: "1CtcGu0rE27EDYDlApHLZtyaTvR7wZAC",
  },
  "demo.yunli.g7.com.cn": {
    name: "yunli-tx",
    url: "//172.16.2.136:5555",
    id: "bm4xr4s",
    skey: "qiJDhcd63V7FmRsoreXGG0uQ7RCGa7NV",
  },
};

const dictConfig = {
  localhost: {
    url: "//test.yunlim.g7s.chinawayltd.com",
  },
  "test.yunlim.g7s.chinawayltd.com": {
    url: "//test.yunlim.g7s.chinawayltd.com",
  },
  "demo.yunli.g7s.chinawayltd.com": {
    url: "//demo.yunli.g7s.chinawayltd.com",
  },
  "wxmobile.yunli.g7.com.cn": {
    url: "//wxmobile.yunli.g7.com.cn",
  },
  "g7s.e-bidding.huoyunren.com": {
    url: "//wxmobile.yunli.g7.com.cn",
  },
  "e-bidding.g7s.huoyunren.com": {
    url: "//wxmobile.yunli.g7.com.cn",
  },
  "test.yunli.g7.com.cn": {
    url: "//test.yunli.g7.com.cn",
  },
  "demo.yunli.g7.com.cn": {
    url: "//demo.yunli.g7.com.cn",
  },
};

const ENV = apiConfig[location.hostname] || apiConfig.localhost;
const serviceName = ENV.name;
const baseUrl = `${ENV.url}`;
const secretKey = ENV.skey;
const accessId = ENV.id;
const dictENV = dictConfig[location.hostname] || dictConfig.localhost;
const dictBaseUrl = `${dictENV.url}/app/archive-wxmobile/proxy/`;

window.fileUploadUrl = `${dictBaseUrl}?m=file&f=upload&t=json`;

const makeApiSign = (reqType, path) => {
  // reqType为get或post
  const timestamp = Date.now();
  const stringToSign = `${reqType.toUpperCase()}\n${timestamp}\n/v1/${serviceName}${path}`;
  const sign = crypto
    .createHmac("sha1", secretKey)
    .update(stringToSign)
    .digest()
    .toString("base64");
  const result = {
    accessid: accessId,
    sign,
    g7timestamp: timestamp,
  };
  if (Cookies.get("_TOKEN_ID")) {
    /* 确定有token再传token */
    result.token = Cookies.get("_TOKEN_ID");
  }
  if (NO_TOKEN_REQUEST.includes(path)) {
    delete result.token;
  }
  return result;
};

/* vegaApi */
const vegaInterceptors = {
  request: [
    (config) => {
      // Do something before request is sent
      const path = config.url.match(/\/v\d+\/([\w-]+)(\/\S+)$/)[2];
      if (!path) {
        console.error("请求参数解析失败");
      }
      if (config.isLoading) {
        Vue.$vux.loading.show({
          text: "Loading",
        });
      }
      // const { accessId, secretKey } = this.environment(this.vega);
      // const sign = makeApiSign('post', path);  //  按照请求的方式进行请求，而不是固定
      if (config.method === "get") {
        const sign = makeApiSign("get", path);
        config.params = Object.assign(sign, config.params);
      } else {
        const sign = makeApiSign("post", path);
        config.data = Object.assign(sign, config.data);
      }
      config.headers = {
        ...config.headers,
        ...window.UCUnified.getUCHeaders(),
      };
      return config;
    },
    (error) => Promise.reject(error),
  ],
  response: [
    (response) => {
      // Do something with response data
      Vue.$vux.loading.hide();
      // 统一处理接口报错
      if (response.data.code !== 0) {
        Vue.$vux.toast.text(response.data.msg);
      }
      if (response.data.sub_code === 1003) {
        Vue.$vux.toast.text(
          "该公司已注册，请直接登录。如果您忘记登录账户，请联系在线客服。"
        );
      }
      if (
        response.data.sub_msg ===
        "param password is too short, minimum length is 7!"
      ) {
        Vue.$vux.toast.text("用户或密码错误！");
      }
      if (errorCode[response.data.sub_code]) {
        response.data.sub_msg = errorCode[response.data.sub_code];
      }
      if (response.data.sub_code === 401) {
        response.data.sub_msg = "登录失败";
      }
      // 1013  是通过获取微信code授权登录的时候返回的。所以不需要提示。
      if (
        response.data.sub_code !== 0 &&
        response.data.sub_code !== 1013 &&
        response.data.sub_code !== 1003 &&
        response.data.sub_msg !==
          "param password is too short, minimum length is 7!"
      ) {
        Vue.$vux.toast.text(response.data.sub_msg);
      }

      return response;
    },
    (error) => {
      // Do something with response error
      Vue.$vux.loading.hide();
      console.log(error);
      return Promise.reject(error);
    },
  ],
};

const interceptors = {
  request: [
    (config) => {
      // Do something before request is sent
      if (config.isLoading) {
        Vue.$vux.loading.show({
          text: "Loading",
        });
      }
      return config;
    },
    (error) => Promise.reject(error),
  ],
  response: [
    (response) => {
      // Do something with response data
      Vue.$vux.loading.hide();
      // 统一处理接口报错
      if (response.data.code !== 0) {
        Vue.$vux.toast.text(response.data.message);
      }
      return response;
    },
    (error) => {
      // Do something with response error
      Vue.$vux.loading.hide();
      console.log(error);
      return Promise.reject(error);
    },
  ],
};

const request = new Request(
  {
    baseURL: baseUrl, // ENV.url,
    timeout: 15000,
    isLoading: true, // 默认开启loading
    transformRequest: [(data) => qs.stringify({ ...data })],
    // transformRequest: [data => ({ ...data })],
  },
  vegaInterceptors
);

const requestBase = new Request(
  {
    baseURL: dictBaseUrl, // ENV.url,
    timeout: 15000,
    isLoading: true, // 默认开启loading
    // transformRequest: [data => qs.stringify(data)],
  },
  interceptors
);

const API = {
  vega: request.createApi(apis),
  base: requestBase.createApi(baseApi),
};

export default API;
// export default request.createApi(apis);
